import React from "react";
import { T } from "Components";

/**
 * İstatistik kartlarının ortak kabuğu: başlık + açıklama + sağ üst aksiyon.
 * Yükleme/hata/boş durumlarını da burada tekilleştiriyoruz ki her kart
 * bağımsız iskelet gösterebilsin.
 */
const DashboardCard = ({
  title,
  description,
  action,
  onAction,
  loading,
  error,
  empty,
  emptyText,
  className = "",
  bodyClassName = "fdash__card__body",
  children,
}) => (
  <section className={`fdash__card ${className}`}>
    <header className="fdash__card__head">
      <div className="fdash__card__title">
        <b>{title}</b>
        {description && <span>{description}</span>}
      </div>
      {action && (
        <a
          className="fdash__card__action"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            if (onAction) onAction();
          }}
        >
          {action}
        </a>
      )}
    </header>

    {error && (
      <div className="fdash__state fdash__state--error">
        {T.Main("Dashboard.Statistics.LoadError")}
      </div>
    )}

    {!error && loading && (
      <div className="fdash__card__body">
        <div className="fdash__skeleton" style={{ height: 18, width: "60%" }} />
        <div className="fdash__skeleton" style={{ height: 14, marginTop: 12 }} />
        <div className="fdash__skeleton" style={{ height: 14, marginTop: 8, width: "80%" }} />
        <div className="fdash__skeleton" style={{ height: 14, marginTop: 8, width: "70%" }} />
      </div>
    )}

    {!error && !loading && empty && (
      <div className="fdash__state">
        {emptyText || T.Main("Dashboard.Statistics.NoData")}
      </div>
    )}

    {!error && !loading && !empty && <div className={bodyClassName}>{children}</div>}
  </section>
);

export default DashboardCard;
